import React from "react";
import { Icon, PlainButton } from "@culturehq/components";

type FilterTagProps = {
  children?: React.ReactNode;
  label: string;
  onRemove: () => void;
};

const FilterTag: React.FC<FilterTagProps> = ({ children, label, onRemove }) => (
  <div className="tag no-select">
    {label} {children && <span className="small">{children}</span>}
    <PlainButton className="close" aria-label="Unselect filter" onClick={onRemove}>
      <Icon icon="close" />
    </PlainButton>
  </div>
);

export default FilterTag;
